import { Switch as BaseSwitch } from 'antd'
import classNames from 'classnames'
import styles from './LargeSwitch.module.scss'

export const LargeSwitch = (props: React.ComponentProps<typeof BaseSwitch>) => (
  <BaseSwitch
    {...props}
    className={classNames(
      props.className,
      styles.switch,
      props.disabled && styles.disabled
    )}
  />
)
